import React from 'react';
import Button from '@material-ui/core/Button';
export default function BrowserIncompatible() {
  return (
    <div style={{ padding: '16px 24px' }}>
      <div style={{ marginBottom: '24px' }}>
        Please use{' '}
        <a href="https://getfirefox.com" target="_blank" rel="noopener noreferrer">
          Firefox{' '}
        </a>
        or{' '}  
        <a href="https://google.com/chrome" target="_blank" rel="noopener noreferrer">
          Chrome{' '}
        </a>
        on Mac or PC.
      </div>
      <Button
        variant="contained"
        color="primary"
        href="https://northsplit.com/virtual-project-office/"
      >
        Return
      </Button>
    </div>
  );
}
